import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionAirConditioning"
const OptionAirConditioningIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M15.336 15.957l-1.604-2.778h3.208l2.53 2.53a.749.749 0 1 0 1.06-1.06l-1.469-1.47H21a1 1 0 0 0 0-2h-1.939l1.469-1.47a.749.749 0 1 0-1.06-1.06l-2.53 2.53h-3.208L15.336 8.4l3.456-.925a.752.752 0 0 0-.388-1.45l-2.007.538.969-1.68a1 1 0 1 0-1.732-1l-.97 1.68-.537-2.007a.752.752 0 0 0-1.45.388l.927 3.456L12 10.179 10.397 7.4l.926-3.456a.75.75 0 1 0-1.449-.388l-.538 2.007-.97-1.68a1 1 0 0 0-1.732 1l.97 1.68-2.008-.538a.752.752 0 0 0-.388 1.45l3.456.925 1.604 2.778H7.061L4.53 8.649a.749.749 0 1 0-1.06 1.06l1.47 1.47H3a1 1 0 0 0 0 2h1.94l-1.47 1.47a.749.749 0 1 0 1.06 1.06l2.531-2.53h3.207l-1.604 2.778-3.456.926a.75.75 0 1 0 .388 1.449l2.008-.538-.97 1.68a1 1 0 0 0 1.732 1l.97-1.68.538 2.008a.75.75 0 1 0 1.449-.39l-.926-3.455L12 14.179l1.604 2.778-.927 3.456a.751.751 0 0 0 1.45.389l.537-2.008.97 1.68a1 1 0 0 0 1.732-1l-.969-1.68 2.007.538a.75.75 0 0 0 .388-1.45z" />
        </svg>
      }
    </span>
  )
}
export default OptionAirConditioningIcon
